/** @jsxRuntime classic */
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga4';

import * as serviceWorker from './serviceWorker';
import * as settings from './util/settings';

import RootContexts from './components/state/RootContexts';

import './css/custom.css';

ReactGA.initialize(settings.Analytics);

ReactDOM.render(<RootContexts />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
